var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DefaultServicePage,{attrs:{"title":"Solid Waste Collection","service-name":_setup.services.solidWaste}})
}
var staticRenderFns = []

export { render, staticRenderFns }